import React from 'react'
import {
  Chart as ChartJS,
  registerables
} from 'chart.js/auto'

import { Line } from "react-chartjs-2"
import { FetchStatistics } from '../../types';

ChartJS.register(
  ...registerables
);

const options = {
  scales: {
    y: {
      grid: {
        display: false,
      },
      ticks: {
        min: 0,
        stepSize: 50
      }
    },
    x: {
      grid: {
        display: false,
      }
    },
  }
}

const ChartLine = ({ dataStatistics }: { dataStatistics: FetchStatistics }) => {
  const labels = dataStatistics.generalStatistics.saleStatistics.map(statistic => statistic.day);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "sales",
        backgroundColor: "#7951F9",
        borderColor: "#7951F9",
        data: dataStatistics.generalStatistics.saleStatistics.map(statistic => statistic.totalSales),
        tension: 0.3
      },
    ],
  };

  return (
    <Line data={data} options={options} />
  )
}

export default ChartLine